/**
 * Status badge for manual ingestion jobs.
 */

import type { JobStatusResponse } from "../../api/clinicalTrialsApiTypes";

const STATUS_CLASSES: Record<JobStatusResponse["status"], string> = {
  queued: "bg-indigo-100 text-indigo-800",
  running: "bg-amber-100 text-amber-800",
  success: "bg-emerald-100 text-emerald-800",
  failed: "bg-red-100 text-red-800",
  interrupted: "bg-orange-100 text-orange-800",
};

interface JobStatusBadgeProps {
  status: JobStatusResponse["status"];
}

/**
 * Render a color-coded ingestion status label.
 *
 * @param props - Current job status
 * @returns Status badge element
 */
export function JobStatusBadge({ status }: JobStatusBadgeProps) {
  return (
    <span
      className={`inline-flex rounded-full px-2.5 py-1 text-xs font-semibold capitalize ${STATUS_CLASSES[status]}`}
    >
      {status}
    </span>
  );
}
